import { ClientModel, ClientRequestModel } from "libs/models/client";
import { ValidationModel } from "libs/models/validate-model";
import { ClientStore } from "store/slices/client";
import { decimalNumberRegex, numberRegex } from "utils/regex";
import translate from "utils/translations";

export const validateEditClientState = (
  state: ClientStore
): ValidationModel<ClientModel> => {
  let validationModel = {} as ValidationModel<ClientModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (
    state.updateClientData.name === null ||
    state.updateClientData.name === ""
  ) {
    validationModel.name = translate("Required_Text", "This field is required");
  }

  if (state.updateClientData.name && state.updateClientData.name.length > 200) {
    validationModel.name = translate("Long_Text", "Text is too long");
  }
  if (
    state.updateClientData.name !== null &&
    state.updateClientData.name !== "" &&
    state.updateClientData.name.length < 2
  ) {
    validationModel.name = translate("Short_Text", "Text is too short");
  }
  if (
    state.updateClientData.website === null ||
    state.updateClientData.website === ""
  ) {
    validationModel.website = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const websiteRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?$/;
  if (
    state.updateClientData.website !== "" &&
    !websiteRegex.test(state.updateClientData.website)
  ) {
    validationModel.website = translate("Website_Error", "Invalid Website");
  }
  if (
    state.updateClientData.phone === null ||
    state.updateClientData.phone === ""
  ) {
    validationModel.phone = translate(
      "Required_Text",
      "This field is required"
    );
  }

  const phoneRegex = /^\d{4,11}$/;
  if (
    state.updateClientData.phone !== "" &&
    !phoneRegex.test(state.updateClientData.phone)
  ) {
    validationModel.phone = translate("Phone_Error", "Invalid phone");
  }
  if (
    state.updateClientData.mobile === null ||
    state.updateClientData.mobile === ""
  ) {
    validationModel.mobile = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const mobileRegex = /^(010|011|012|015)\d{8}$/;
  if (
    state.updateClientData.mobile !== "" &&
    !mobileRegex.test(state.updateClientData.mobile)
  ) {
    validationModel.mobile = translate("Mobile_Error", "Invalid mobile");
  }
  if (
    state.updateClientData.clickingFees === null ||
    state.updateClientData.clickingFees === ""
  ) {
    validationModel.clickingFees = translate(
      "Required_Text",
      "This field is required"
    );
  }
  if (
    state.updateClientData.invoiceGenerationWeeklyPeriod === null ||
    state.updateClientData.invoiceGenerationWeeklyPeriod === ""
  ) {
    validationModel.invoiceGenerationWeeklyPeriod = translate(
      "Required_Text",
      "This field is required"
    );
  }

  if (
    state.updateClientData.clickingFees !== undefined &&
    !decimalNumberRegex.test(state.updateClientData.clickingFees.toString())
  ) {
    validationModel.clickingFees = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.updateClientData.invoiceGenerationWeeklyPeriod !== undefined &&
    !numberRegex.test(
      state.updateClientData.invoiceGenerationWeeklyPeriod.toString()
    )
  ) {
    validationModel.invoiceGenerationWeeklyPeriod = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (state.logoId === null || state.logoId === "") {
    validationModel.logo = translate("Required_Text", "This field is required");
  }

  if (
    state.commercialRegisterFiledId === null ||
    state.commercialRegisterFiledId === ""
  ) {
    validationModel.commercialRegisterFiled = translate(
      "Required_Text",
      "This field is required"
    );
  }
  if (
    state.taxRegistrationFileId === null ||
    state.taxRegistrationFileId === ""
  ) {
    validationModel.taxRegistrationFile = translate(
      "Required_Text",
      "This field is required"
    );
  }

  return validationModel;
};
